// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div:has(> app-alerta):has(> app-button) {
  display: flex;
  flex-direction: column;
}
div:has(> app-alerta):has(> app-button) app-button {
  align-self: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/app/components/plantillas-documentos/plantillas-documentos.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;AAAI;EACI,oBAAA;AAER","sourcesContent":["div:has(> app-alerta):has(> app-button) {\n    display: flex;\n    flex-direction: column;\n    & app-button {\n        align-self: flex-end;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
